import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ConsentService } from '../../services/consent.service';
import { LanguageService } from '../../services/language.service';
import { SettingsService } from '../../services/settings.service';

interface IConsentTexts {
  title: string;
  body: string;
  acceptAll: string;
  rejectAll: string;
  settings: string;
}

const FALLBACK_LANGUAGE = 'en';

const CONSENT_TEXTS: Record<string, IConsentTexts> = {
  en: {
    title: 'Cookies',
    body: 'We use analytics and marketing cookies to improve our service and to measure advertising. You can accept or reject them. Necessary cookies are always used.',
    acceptAll: 'Accept all',
    rejectAll: 'Reject all',
    settings: 'Cookie settings'
  },
  fi: {
    title: 'Evästeet',
    body: 'Käytämme analytiikka- ja markkinointievästeitä palvelumme kehittämiseen ja mainonnan mittaamiseen. Voit hyväksyä tai hylätä ne. Välttämättömiä evästeitä käytetään aina.',
    acceptAll: 'Hyväksy kaikki',
    rejectAll: 'Hylkää kaikki',
    settings: 'Evästeasetukset'
  },
  sv: {
    title: 'Cookies',
    body: 'Vi använder analys- och marknadsföringscookies för att utveckla vår tjänst och mäta annonsering. Du kan godkänna eller avvisa dem. Nödvändiga cookies används alltid.',
    acceptAll: 'Godkänn alla',
    rejectAll: 'Avvisa alla',
    settings: 'Cookieinställningar'
  },
  de: {
    title: 'Cookies',
    body: 'Wir verwenden Analyse- und Marketing-Cookies, um unseren Service zu verbessern und Werbung zu messen. Sie können diese akzeptieren oder ablehnen. Notwendige Cookies werden immer verwendet.',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    settings: 'Cookie-Einstellungen'
  }
};

/**
 * Asks for analytics and marketing consent when no known CMP consent is visible (see ConsentService).
 * Accept and reject are equally prominent.
 */
@Component({
  selector: 'hlx-consent-banner',
  imports: [ButtonModule],
  templateUrl: './consent-banner.component.html',
  styleUrl: './consent-banner.component.scss'
})
export class ConsentBannerComponent {

  bannerOpen = false;

  constructor(
    public consent: ConsentService,
    private languageService: LanguageService,
    private settings: SettingsService
  ) {
    this.consent.bannerOpen$.subscribe(open => this.bannerOpen = open);
  }

  get texts(): IConsentTexts {
    const language = (this.languageService.getCurrentLanguage() || this.settings.get('app.defaultLanguage') || FALLBACK_LANGUAGE)
      .toString()
      .toLowerCase()
      .substring(0, 2);
    return CONSENT_TEXTS[language] ?? CONSENT_TEXTS[FALLBACK_LANGUAGE];
  }
}
